import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'
import AppHomeFooterItem from '../app-home-footer-item'

export default
{
    name: 'app-home-footer',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon,
        AppHomeFooterItem
    },

    props: {
        activeIndex: { type: Number, default: 0 },
        activeLevel: { type: Number, default: 0 },
        activeNbLevels: { type: Number, default: 0 },
        NBSLIDE: { type: Number, default: 0 }
    },

    data() {
        return {
            progressBarScale: 0.25,
            isNextDisabled: false
        }
    },

    watch: {
        activeIndex: 'onActiveChange',
        activeLevel: 'onActiveChange'
    },

    methods: {
        onActiveChange() {
            this.updateProgressBar()

            if (this.activeIndex === this.NBSLIDE - 1) {
                if (this.activeNbLevels !== 0) {
                    if (this.activeLevel === this.activeNbLevels) {
                        this.isNextDisabled = true
                    } else {
                        this.isNextDisabled = false
                    }
                } else {
                    this.isNextDisabled = true
                }
            } else {
                this.isNextDisabled = false
            }
        },

        updateProgressBar() {
            let currIndex = this.activeIndex

            if (this.activeNbLevels !== 0) {
                currIndex = this.activeIndex - 1 + (this.activeLevel / this.activeNbLevels)
            }

            this.progressBarScale = (1 / (this.NBSLIDE + 1)) + (currIndex * (1 / (this.NBSLIDE + 1)))
        },

        onMouseenter() {
            if (!this.$root.isTouch) this.eventHub.$emit('app-home-footer:mouseenter')
        },

        onMouseleave() {
            if (!this.$root.isTouch) this.eventHub.$emit('app-home-footer:mouseleave')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-home-footer/script.js